/**
 * ISG Utilities — internationalisation.
 *
 * A thin adapter over the estate's shared engine in `@isg/ui-kit/js/i18n`.
 * Pages import `t` / `getLocale` from here.
 *
 * This app's catalogues are NESTED (`{"nav": {"all_tools": "…"}}`). The base
 * (en-GB) is registered at module scope; de / cs / en-US are loaded on demand
 * from ./locales/ when the signed-in user's stored locale asks for them.
 */
import {
  registerAppMessages, initI18n as initShared,
  t, getLocale, setLocale, onLocaleChange, getAvailableLocales,
} from '@isg/ui-kit';

import enGB from './en-GB.json';

// ⚠️ AT MODULE SCOPE — any t() evaluated during the import graph would
// otherwise run before boot and render its own key.
registerAppMessages('en-GB', enGB);

export { t, getLocale, setLocale, onLocaleChange, getAvailableLocales };

/**
 * Boot i18n for this app with the signed-in user's stored locale
 * (`user.locale` from isg_core), or null when signed out.
 */
export function initI18n(user) {
  // What ui-kit's startAppI18n() does, named initI18n() like the intranet's and
  // induction's adapters (the programme's audit looks for an initI18n() boot).
  return initShared({
    base: enGB,
    // Literal template so Vite can glob ./locales/*.json at build time.
    load: (locale) => import(`./locales/${locale}.json`),
    locale: (user && user.locale) || null,
  });
}
